module.exports = __webpack_public_path__ + "img/noDoc-uploaded.682cb377.svg";